import BottomSheet from "./BottomSheet";

// HAYD does not allow a coupon and the HAYD wallet on the same order, so the shopper picks one here.
const WalletCouponSheet = ({ open, container, title, message, confirmLabel, cancelLabel, onConfirm, onCancel }) => (
  <BottomSheet open={open} onOpenChange={(next) => !next && onCancel()} title={title} container={container}>
    <div className="bg-white px-4 pb-6 pt-1">
      <p className="text-[14px] general-sans-regular text-gray-600">{message}</p>
      <button
        type="button"
        onClick={onConfirm}
        className="mt-5 w-full h-12 rounded-lg bg-black text-white text-[16px] supreme-medium"
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="mt-3 w-full h-12 rounded-lg border border-gray-300 text-[16px] supreme-medium"
      >
        {cancelLabel}
      </button>
    </div>
  </BottomSheet>
);

export default WalletCouponSheet;
